import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failureBulkUploadQuestions,
    successBulkUploadQuestions,
} from "./BulkUploadQuestionsSlice";

const BulkUploadQuestionsApi = (action: PayloadAction<File>) => {
    const formData = new FormData();
    formData.append("file", action.payload);

    return api.post("/api/question/bulk-upload", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export function* BulkUploadQuestionsCall(action: PayloadAction<File>) {
    try {
        const response: AxiosResponse = yield call(BulkUploadQuestionsApi, action);
        yield put(successBulkUploadQuestions(response.data));
    } catch (error) {
        yield put(failureBulkUploadQuestions(error));
    }
}
